import { render } from "./ComparatorViewDev.vue?vue&type=template&id=78d655d4&xmlns%3Acursor=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./ComparatorViewDev.vue?vue&type=script&lang=js"
export * from "./ComparatorViewDev.vue?vue&type=script&lang=js"

import exportComponent from "/home/PersonaExplorer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__